import { Component } from '@angular/core';
import { DashboardComponent } from '../dashboard/dashboard.component';
import { ButtonComponent } from '../../utilities/button/button.component';
import { ModalComponent } from '../../components/modal/modal.component';
import { DropdownComponent } from '../../utilities/dropdown/dropdown.component';
import { InputComponent } from '../../utilities/input/input.component';
import { TextAreaComponent } from '../../utilities/text-area/text-area.component';
import { CommonModule } from '@angular/common';
import { RewardService } from '../../services/reward.service';
import { DropdownSearchComponent } from '../../components/dropdown-search/dropdown-search.component';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { FormsModule } from '@angular/forms';
import { TableComponent } from '../../components/table/table.component';
import { PaginationComponent } from '../../utilities/pagination/pagination.component';
import { SideModalComponent } from '../../components/side-modal/side-modal.component';

@Component({
  selector: 'app-rewards',
  standalone: true,
  imports: [
    FormsModule,
    DashboardComponent,
    ButtonComponent,
    ModalComponent,
    InputComponent,
    TextAreaComponent,
    CommonModule,
    DropdownSearchComponent,
    DropdownComponent,
    TableComponent,
    PaginationComponent,
    SideModalComponent,
  ],
  templateUrl: './rewards.component.html',
  styleUrl: './rewards.component.scss',
})
export class RewardsComponent {
  modalOpen: boolean = false;
  detailsModalOpen: boolean = false;
  usageFormatIndex: number = 1;
  taskListIndex: number = 1;
  createRewardPage: number = 1;
  maxPages: number = 2;
  loading: boolean = false;
  rewardTypes: any[] = [];
  durationOptions: any = ['Daily', 'Monthly', 'Yearly'];
  subDdurationOptions: any = [];
  tableHeader: any[] = [];
  tableData: any[] = [];
  limit: number = 25;
  page: number = 1;
  rewards: any;
  fromDate: any;
  toDate: any;
  filterData: any;
  singleReward: any;
  fetchingData: boolean = false;
  totalRewards: number = 1;
  emptyTableState = {
    title: 'No data found',
    label: 'You have no active customers',
  };
  editModal: boolean = false;
  constructor(
    private rewardService: RewardService,
    private notification: NzNotificationService
  ) {
    this.fromDate = new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      1
    );
    this.toDate = new Date(
      new Date().getFullYear(),
      new Date().getMonth() + 1,
      0
    );
    this.filterData = [
      {
        type: 'date-range',
        name: 'date-range',
        label: 'Date Range',
        fromDate: this.fromDate,
        toDate: this.toDate,
        fromDateValue: '',
        toDateValue: '',
      },
      {
        type: 'select',
        name: 'channel',
        label: 'Channel',
        value: '',
        defaultValue: '',
        options: [
          { key: '', value: 'All' },
          { key: 'wallet', value: 'Wallet' },
          { key: 'card', value: 'Card' },
          { key: 'ussd', value: 'Ussd' },
          { key: 'loyaltyCard', value: 'Loyalty Card' },
          { key: 'onlineTransfer', value: 'Online Transfer' },
        ],
      },
      {
        type: 'select',
        name: 'tansaction-type',
        label: 'Transaction Type',
        value: '',
        defaultValue: '',
        options: [
          { key: '', value: 'All' },
          { key: 'funding', value: 'Funding' },
          { key: 'withdrawal', value: 'Withdraw' },
        ],
      },
      {
        type: 'select',
        name: 'tansaction-status',
        label: 'Transaction Status',
        value: '',
        defaultValue: '',
        options: [
          { key: '', value: 'All' },
          { key: 'failed', value: 'Failed' },
          { key: 'success', value: 'Success' },
          { key: 'pending', value: 'Pending' },
        ],
      },
      {
        type: 'select',
        name: 'transaction-initiator',
        label: 'Transaction Initiator',
        value: '',
        defaultValue: '',
        options: [
          { key: '', value: 'All' },
          { key: 'company', value: 'Company' },
          { key: 'customer', value: 'Customer' },
        ],
      },
    ];
  }

  headers = ['Name', 'Age', 'Location'];
  data = [
    { Name: 'John Doe', Age: 30, Location: 'New York' },
    { Name: 'Jane Smith', Age: 25, Location: 'Los Angeles' },
    { Name: 'Mike Johnson', Age: 35, Location: 'Chicago' },
  ];

  columnWidths = ['40%', '30%', '30%'];
  editReward: any = {
    rewardTypeId: '',
    name: '',
    rewardExpiration: '',
    rewardExpirationDuration: '',
    activeCycleCount: '',
    minimumBalanceAmount: '',
    activationCycleType: '',
    usageDescription: '',
    rewardActivationMinimumCount: '',
    rewardUsageFormat: [{ name: '', percentageUsage: '' }],
    // taskList: [{ name: '', taskDescription: '', isCompulsory: false }],
  };
  newReward: any = {
    rewardTypeId: '',
    name: '',
    rewardExpiration: '',
    rewardExpirationDuration: '',
    activeCycleCount: '',
    minimumBalanceAmount: '',
    activationCycleType: '',
    usageDescription: '',
    rewardActivationMinimumCount: '',
    rewardUsageFormat: [{ name: '', percentageUsage: '' }],
    // taskList: [
    //   { name: '', taskDescription: '', isCompulsory: false },
    // ],
  };
  editRewardErrors: any = {
    rewardTypeId: '',
    name: '',
    rewardExpiration: '',
    rewardExpirationDuration: '',
    activeCycleCount: '',
    minimumBalanceAmount: '',
    activationCycleType: '',
    usageDescription: '',
    rewardActivationMinimumCount: '',
    rewardUsageFormat: [] as any[],
    taskList: [] as any[],
  };
  errors: any = {
    rewardTypeId: '',
    name: '',
    rewardExpiration: '',
    rewardExpirationDuration: '',
    activeCycleCount: '',
    minimumBalanceAmount: '',
    activationCycleType: '',
    usageDescription: '',
    rewardActivationMinimumCount: '',
    rewardUsageFormat: [] as any[],
    taskList: [] as any[],
  };
  radioState: boolean = false;

  ngOnInit() {
    this.getRewardTypes();
    this.getRewards();
  }

  onItemSelected(item: any) {
    // console.log(this.newReward);
    if (item?.name === 'Tasks') {
      this.maxPages = 3;
      this.newReward.taskList = [];
      this.newReward.taskList.push({
        name: '',
        taskDescription: '',
        isActive: false,
      });
      // console.log(this.newReward);
    }
    this.newReward.rewardTypeId = item?._id;
  }

  handleInput(data: { title: string; value: string }) {
    this.newReward[data.title] = data.value;
    if (data.value === '') {
      this.errors[data.title] = 'Required*';
      return;
    } else {
      this.errors[data.title] = '';
    }
  }
  returnExpirationValue(value: string): string {
    if (value === 'Monthly') return ' months';
    if (value === 'Daily') return ' days';
    if (value === 'Yearly') return ' years';

    return '';
  }

  setUsageTypeName(value: string, index: number) {
    this.newReward.rewardUsageFormat[index].name = value;
  }
  setTaskListName(value: string, index: number) {
    this.newReward.taskList[index].name = value;
  }
  setTaskListDescription(value: string, index: number) {
    this.newReward.taskList[index].taskDescription = value;
  }
  setTaskListIsCompulsory(value: string, index: number) {
    this.newReward.taskList[index].isCompulsory = value;
  }

  setPercentage(value: number, index: number) {
    this.newReward.rewardUsageFormat[index].percentageUsage = value;
  }

  addTask() {
    this.newReward.taskList.push({
      name: '',
      taskDescription: '',
      isActive: false,
    });
  }
  toggleTaskState(index: number) {
    this.newReward.taskList[index].isCompulsory =
      !this.newReward.taskList[index].isCompulsory;
  }
  addReward() {
    this.newReward.rewardUsageFormat.push({ name: '', percentageUsage: '' });
  }

  removeTask(index: number) {
    if (this.newReward.taskList.length > 1) {
      this.newReward.taskList.splice(index, 1);
    }
  }
  logTasks() {
    // console.log(this.newReward.taskList);
  }

  removeReward(index: number) {
    if (this.newReward.rewardUsageFormat.length > 1) {
      this.newReward.rewardUsageFormat.splice(index, 1);
    }
  }

  submitForm() {
    // console.log('Submitted Data:', this.newReward);
  }
  submit() {
    // console.log(this.newReward);
  }
  nextPage = () => {
    // console.log(this.newReward);
    if (this.createRewardPage < this.maxPages) this.createRewardPage++;
  };
  previousPage = () => {
    if (this.createRewardPage >= 1) this.createRewardPage--;
  };
  openModal = () => {
    this.modalOpen = true;
  };
  closeModal = () => {
    this.modalOpen = false;
  };
  closeDetailsModal() {
    this.detailsModalOpen = false;
  }
  openDetailsModal(id: string) {
    this.singleReward = this.rewards.find((obj: any) => obj._id === id);
    // console.log(this.singleReward);
    this.detailsModalOpen = true;
    this.editReward.rewardTypeId = this.singleReward.rewardType._id;
    this.editReward.name = this.singleReward.name;
    this.editReward.rewardExpiration = this.singleReward.rewardExpiration;
    this.editReward.rewardExpirationDuration =
      this.singleReward.rewardExpirationDuration;
    this.editReward.activeCycleCount = this.singleReward.activeCycleCount;
    this.editReward.minimumBalanceAmount =
      this.singleReward.minimumBalanceAmount;
    this.editReward.activationCycleType = this.singleReward.activationCycleType;
    this.editReward.usageDescription = this.singleReward.usageDescription;
    this.editReward.rewardActivationMinimumCount =
      this.singleReward.rewardActivationMinimumCount;
    this.editReward.rewardUsageFormat = this.singleReward.rewardUsageFormat;
    if (this.singleReward.taskList) {
      this.singleReward.taskList = [];
      this.editReward.taskList = this.singleReward.taskList;
    }
    // console.log('edit reward', this.editReward)
  }
  openEditModal() {
    this.editModal = true;
  }
  closeEditModal() {
    this.editModal = false;
  }
  // setExpiry = (date: string) => {
  //   this.newReward.rewardExpiration = date;
  // };
  formatDate(date: string) {
    const dateTimeString = date;
    const dateTime = new Date(dateTimeString);
    return dateTime.toLocaleString();
  }

  getRewardTypes() {
    this.rewardService.getRewardTypes().subscribe({
      next: (res: any) => {
        // console.log(res);
        this.rewardTypes = res.data;
      },
      error: (err) => {
        this.notification.error('Error', 'Failed to get reward types', {
          nzClass: 'notification',
        });
      },
    });
  }
  createReward = () => {
    // console.log(this.newReward);
    this.loading = true;
    this.rewardService.createReward(this.newReward).subscribe(
      (res: any) => {
        this.getRewards();
        this.notification.success('Success', 'Reward Created', {
          nzClass: 'notification',
        });
        this.modalOpen = false;
        this.loading = false;
      },
      (error) => {
        this.loading = false;
        this.notification.error('Error', 'Something went wrong', {
          nzClass: 'notification',
        });
        this.modalOpen = false;
      }
    );
  };
  getRewards() {
    this.fetchingData = true;
    this.rewardService.getRewards().subscribe({
      next: (res: any) => {
        this.fetchingData = false;
        // console.log(res);
        this.rewards = res.data;
        this.tableHeader = [
          { name: 'Reward Name', ratio: { width: '33%', minWidth: '204px' } },
          { name: 'Reward Type', ratio: { width: '33%', minWidth: '83px' } },
          { name: 'Expiry Date', ratio: { width: '33%', minWidth: '83px' } },
          {
            name: 'Minimum Balance',
            ratio: { width: '33%', minWidth: '83px' },
          },
        ];
        this.tableData = this.rewards.map((reward: any, n: number) => {
          // console.log('tlocation', transaction.transactionCharges);
          // await this.getLocationBalance(this.locations[n].hasOwnProperty('sales_point_account'), n)
          return [
            {
              name: {
                title: reward.name,
                label: this.formatDate(reward.createdAt),
              },
              ratio: { width: '33%', minWidth: '180px' },
              id: reward._id,
            },
            {
              name: {
                title: `<span>${reward.rewardType.name}</span>`,
              },
              ratio: { width: '33%', minWidth: '50px' },
              id: reward._id,
            },
            {
              name: {
                title: `<span>${
                  reward.rewardExpiration
                }&nbsp;</span><span>${this.returnExpirationValue(
                  reward.rewardExpirationDuration
                )}</span>`,
              },
              ratio: { width: '33%', minWidth: '50px' },
              id: reward._id,
            },
            {
              name: {
                title: `<span>${reward.minimumBalanceAmount}</span>`,
              },
              ratio: { width: '33%', minWidth: '50px' },
              id: reward._id,
            },
          ];
        });
      },
      error: (err) => {
        this.fetchingData = false;
        this.notification.error('Error', 'Failed to fetch rewards', {
          nzClass: 'notification',
        });
      },
    });
  }
  applyFilter(data: any) {}
  search(data: any) {}
  changeLimit(data: any) {}
  refreshList() {}
}
